import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = {
  key: 2,
  class: "pl-2 pt-2"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "text-center",
  width: "64px"
}
const _hoisted_7 = {
  key: 0,
  class: "text-left"
}
const _hoisted_8 = {
  key: 1,
  class: "text-left"
}
const _hoisted_9 = {
  key: 2,
  class: "text-left"
}
const _hoisted_10 = {
  key: 3,
  class: "text-left"
}
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = { class: "pl-4" }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = { class: "pl-4" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { class: "pl-4" }
const _hoisted_17 = { class: "text-right" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = {
  key: 0,
  class: "px-0"
}
const _hoisted_21 = {
  colspan: "100",
  class: "px-0"
}
const _hoisted_22 = { class: "mr-6" }
const _hoisted_23 = { class: "mr-6" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "mr-6" }
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = { class: "mr-6" }
const _hoisted_28 = {
  key: 0,
  class: "text-right"
}
const _hoisted_29 = {
  key: 1,
  class: "text-right"
}
const _hoisted_30 = { class: "mr-6" }
const _hoisted_31 = {
  key: 1,
  class: "text-right"
}
const _hoisted_32 = { class: "d-flex align-center text-center" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "pl-4" }
const _hoisted_36 = { class: "pl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_AccountableAccountBalanceDetail = _resolveComponent("AccountableAccountBalanceDetail")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "d-flex justify-space-between mb-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            class: "d-flex flex-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "11",
                    class: "d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _cache[50] || (_cache[50] = _createElementVNode("h2", null, "Rapprochements bancaires", -1)),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_icon, _mergeProps(props, {
                            size: "large",
                            class: "ml-2",
                            icon: "$oss-help"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[36] || (_cache[36] = _createElementVNode("h3", null, " bobbee a une particularité : les mouvements bancaires ne sont pas saisis, mais importés des données bancaire. ", -1)),
                          _cache[37] || (_cache[37] = _createElementVNode("p", { class: "mb-0" }, " Les paiements émis ou reçus, pas encore encaissés, n'apparaissent pas dans les comptes 512, mais isolés dans des comptes d'attente. ", -1)),
                          _cache[38] || (_cache[38] = _createElementVNode("p", { class: "mb-0" }, " En conséquence, le solde comptable et le solde du relevé bancaire sont identiques. ", -1)),
                          _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                          _cache[40] || (_cache[40] = _createElementVNode("h4", null, "Les seuls écarts possibles sont dus à :", -1)),
                          _cache[41] || (_cache[41] = _createElementVNode("p", { class: "mb-0" }, " - des écritures manuelles (ODs) qui mouvementent le compte 512 : il vous faut alors modifier l'écriture et la passer dans le compte d'attente correspondant ", -1)),
                          _cache[42] || (_cache[42] = _createElementVNode("p", { class: "mb-0" }, "- des mouvements importés plusieurs fois", -1)),
                          _cache[43] || (_cache[43] = _createElementVNode("p", { class: "mb-0" }, "- des mouvements manquants", -1)),
                          _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
                          _cache[45] || (_cache[45] = _createElementVNode("h3", null, "bobbee vous fournit plusieurs outils pour analyser cela :", -1)),
                          _cache[46] || (_cache[46] = _createElementVNode("h4", null, "- au niveau du rapprochement bancaire :", -1)),
                          _cache[47] || (_cache[47] = _createElementVNode("div", { class: "pl-4" }, [
                            _createElementVNode("h4", { class: "mb-0" }, " - si l'écart de la dernière ligne est nul, le rapprochement est correct. "),
                            _createElementVNode("p", { class: "mb-0" }, " - dans le cas contraire, la colonne \"Origine de l'écart\" vous permet d'identifier la période à analyser "),
                            _createElementVNode("p", { class: "mb-0" }, " - vous avez la possibilité d'insérer manuellement des soldes bancaires intermédiaires, afin d'affiner la recherche ")
                          ], -1)),
                          _cache[48] || (_cache[48] = _createElementVNode("p", { class: "mb-0" }, [
                            _createTextVNode(" - en cas de mouvements manquants, vous pouvez les importer via "),
                            _createElementVNode("b", null, "Banques - Import - csv ou xlsx")
                          ], -1)),
                          _cache[49] || (_cache[49] = _createElementVNode("p", { class: "mb-0" }, [
                            _createTextVNode(" - en cas de doublons, le chemin d'accès est le suivant : "),
                            _createElementVNode("b", null, "Banques - Filtres - Contrôles - Doublons avec libellé ou Doublons sans libellé")
                          ], -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }),
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Lier un document"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-upload",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Message"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-chat",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod || _ctx.validated || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod
                        ,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.storeComments())),
                    "data-cy": "CheckBankReconciliation-save",
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => _cache[51] || (_cache[51] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.disabledBtnGlobalValidation ||
                            _ctx.loading ||
                            _ctx.dataLoading ||
                            !_ctx.accountingPeriod
                        ,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFunction())),
                    "data-cy": "CheckBankReconciliation-valid",
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.isEnableReview)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[52] || (_cache[52] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-up",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.storeComments('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-down",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.storeComments('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _cache[53] || (_cache[53] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_prev, _mergeProps(props, {
                        disabled: !_ctx.previousControl,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_next, _mergeProps(props, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                        disabled: !_ctx.nextControl
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                    ]),
                    _: 1
                  }),
                  _cache[55] || (_cache[55] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px","color":"'{{secondary}}'"} }, null, -1)),
                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                        class: "mx-1",
                        color: "secondary"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { nav: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayActivityDialog = true)),
                            title: `Afficher l'activité`
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[54] || (_cache[54] = [
                                  _createTextVNode("$oss-activity")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading || _ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              elevation: "0",
              style: {"background-color":"#ffffff","border-radius":"25px","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      class: "mr-3"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.accountingPeriod)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "d-flex flex-column justify-center align-center mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2 mb-1",
                    size: "large"
                  }, {
                    default: _withCtx(() => _cache[56] || (_cache[56] = [
                      _createTextVNode(" $oss-warning ")
                    ])),
                    _: 1
                  }),
                  _cache[57] || (_cache[57] = _createElementVNode("h3", null, "Aucune période sélectionnée", -1))
                ]),
                _: 1
              }))
            : (!_ctx.bankAccounts || !_ctx.bankAccounts.length)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_4, "Aucun compte bancaire"))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (_ctx.closedPeriod)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": "",
                        class: "d-flex flex-column justify-center align-center mb-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            class: "mr-2 mb-1",
                            size: "large"
                          }, {
                            default: _withCtx(() => _cache[58] || (_cache[58] = [
                              _createTextVNode(" $oss-warning ")
                            ])),
                            _: 1
                          }),
                          _cache[59] || (_cache[59] = _createElementVNode("h3", null, "Période Clôturée", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_oss_data_table, {
                    headers: _ctx.headersBankAccounts,
                    items: _ctx.bankAccounts,
                    striped: true,
                    dense: true,
                    loading: _ctx.loading,
                    "fixed-header": "",
                    "max-height": "60vh"
                  }, {
                    item: _withCtx(({ item, index: bankAccountIndex }) => [
                      (_openBlock(), _createElementBlock("tr", {
                        class: "bankLine",
                        key: item.id,
                        onClick: ($event: any) => (_ctx.addRemoveBankAccountExpanded(item))
                      }, [
                        _createElementVNode("td", _hoisted_6, [
                          _createVNode(_component_v_icon, {
                            "data-cy": 'CheckBankReconciliation-chevron-' + item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.isBankAccountExpanded(item)
                                            ? "$fa-chevron-up"
                                            : "$fa-chevron-down"), 1)
                            ]),
                            _: 2
                          }, 1032, ["data-cy"])
                        ]),
                        (item.name && item.iban)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                              _createElementVNode("strong", null, _toDisplayString(item.name) + " - " + _toDisplayString(item.iban), 1)
                            ]))
                          : (item.name && item.number)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                                _createElementVNode("strong", null, _toDisplayString(item.name) + " - " + _toDisplayString(item.number), 1)
                              ]))
                            : (item.name)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                                  _createElementVNode("strong", null, _toDisplayString(item.name), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_10, _cache[60] || (_cache[60] = [
                                  _createElementVNode("strong", null, "Pas de nom ou numéro de compte bancaire", -1)
                                ]))),
                        _createElementVNode("td", _hoisted_11, [
                          _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            item.generalLedgerBalance,
                                            undefined,
                                        )), 1)
                        ]),
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.newCommonFormatCurrency(item.importedBalance, undefined)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_15, [
                          _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.newCommonFormatCurrency(item.manualJustification, undefined)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("h5", {
                            class: _normalizeClass(["pl-4", item.balanceReconciliationFront ? 'text-error' : ''])
                          }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            item.balanceReconciliationFront,
                                            undefined,
                                        )), 3)
                        ]),
                        _createElementVNode("td", _hoisted_18, [
                          _createVNode(_component_v_menu, { "offset-y": "" }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                                class: "mx-1",
                                color: "secondary",
                                "data-cy": "CheckBankReconciliation-moreVert"
                              }), null, 16)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, {
                                    disabled: 
                                                _ctx.closedPeriod &&
                                                (!item.auditCheckResults ||
                                                    !item.auditCheckResults[0] ||
                                                    !item.auditCheckResults[0].id)
                                            ,
                                    title: "Supprimer les justifications manuelles et les\n                                                commentaires",
                                    onClick: ($event: any) => (
                                                _ctx.deleteAuditCheckResult(item.auditCheckResults[0].id)
                                            ),
                                    "data-cy": "CheckBankReconciliation-supprimerJustificatifs"
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => _cache[61] || (_cache[61] = [
                                          _createTextVNode(" $oss-trash ")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled", "onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("td", _hoisted_19, [
                          (item.validated)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                color: "primary"
                              }, {
                                default: _withCtx(() => _cache[62] || (_cache[62] = [
                                  _createTextVNode(" $check_circle ")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_5)),
                      (_ctx.isBankAccountExpanded(item))
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                            _createElementVNode("td", _hoisted_21, [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"width":"100%"},
                                onClick: ($event: any) => (_ctx.addRemoveBankAccountGL(item)),
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pt-0 pl-8",
                                    cols: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "small",
                                        icon: 
                                                !_ctx.isBankAccountGLExpanded(item)
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pl-4",
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => _cache[63] || (_cache[63] = [
                                      _createTextVNode(" Ecritures déjà encaissées (c/512000) (I) ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pl-4 justify-end",
                                    cols: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                item.generalLedgerBalance,
                                                undefined,
                                            )), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_spacer)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _withDirectives(_createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"width":"100%"},
                                class: "px-4 pb-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      (_ctx.accountableAccountInfo)
                                        ? (_openBlock(), _createBlock(_component_AccountableAccountBalanceDetail, {
                                            key: 0,
                                            companyId: _ctx.companyId,
                                            accountingPeriodId: _ctx.accountingPeriodId,
                                            accountableAccountInfo: 
                                                _ctx.accountableAccountInfo(
                                                    item.name,
                                                    item.accountableAccountName,
                                                )
                                            ,
                                            notReconciliated: _ctx.withoutLettering,
                                            withoutBank: _ctx.withoutBank,
                                            withoutDocument: _ctx.withoutDocument,
                                            inAccountingTransactions: _ctx.accountingTransactions
                                          }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountInfo", "notReconciliated", "withoutBank", "withoutDocument", "inAccountingTransactions"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1536), [
                                [_vShow, _ctx.isBankAccountGLExpanded(item)]
                              ]),
                              _createVNode(_component_v_divider),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"width":"100%"},
                                onClick: ($event: any) => (_ctx.addRemoveBankAccountBalances(item)),
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pt-0 pl-8",
                                    cols: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "small",
                                        "data-cy": "CheckBankReconciliation-soldeDernierReleverBancaire",
                                        icon: 
                                                !_ctx.isBankAccountBalancesExpanded(item)
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pl-4",
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => _cache[64] || (_cache[64] = [
                                      _createTextVNode(" Solde dernier relevé bancaire (II) ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pl-4 justify-end",
                                    cols: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.importedBalance, undefined)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_spacer)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              (_ctx.isBankAccountBalancesExpanded(item))
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 0,
                                    "no-gutters": "",
                                    style: {"width":"100%"},
                                    class: "px-4 pb-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createBlock(_component_v_card, {
                                            style: {"background":"#f4f4f4"},
                                            key: _ctx.refreshKey,
                                            elevation: "0",
                                            class: "pa-4"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_data_table, {
                                                headers: _ctx.headersBalancesTable,
                                                items: item.balances,
                                                striped: true,
                                                dense: true,
                                                "fixed-header": true,
                                                height: "40vh"
                                              }, {
                                                "header.checkbox": _withCtx(() => [
                                                  _createVNode(_component_v_checkbox, {
                                                    class: "pa-0 ma-0 mr-1",
                                                    ripple: false,
                                                    "hide-details": "",
                                                    modelValue: _ctx.allAreSelected,
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.allAreSelected) = $event)),
                                                    onClick: ($event: any) => (_ctx.selectAll(item))
                                                  }, null, 8, ["modelValue", "onClick"])
                                                ]),
                                                item: _withCtx(({
                                                        item: balance,
                                                        index: balanceIndex,
                                                    }) => [
                                                  _createElementVNode("tr", null, [
                                                    _createElementVNode("td", null, [
                                                      (
                                                                    item.id &&
                                                                    balance.selected &&
                                                                    balance.selected.id &&
                                                                    balance.selected.type ===
                                                                        'MANUAL'
                                                                )
                                                        ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                                            key: 0,
                                                            "hide-details": "",
                                                            class: "pa-0 ma-0 mr-1",
                                                            modelValue: balance.selected.checked,
                                                            "onUpdate:modelValue": ($event: any) => ((balance.selected.checked) = $event),
                                                            value: balance.selected.checkBoxId,
                                                            onClick: _withModifiers(($event: any) => (
                                                                    _ctx.selectBalance(item, balance)
                                                                ), ["stop"])
                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "onClick"]))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.formatDate(balance.date)), 1),
                                                    _createElementVNode("td", _hoisted_23, [
                                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_col, { cols: "2" }, {
                                                            default: _withCtx(() => [
                                                              (
                                                                            balanceIndex >= 0 &&
                                                                            balance &&
                                                                            balance.selected &&
                                                                            balance.selected.type !=
                                                                                'MANUAL'
                                                                        )
                                                                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                                    key: 0,
                                                                    icon: "$remove_red_eye",
                                                                    color: "primary",
                                                                    onClick: _withModifiers(($event: any) => (
                                                                            _ctx.showBTs(
                                                                                item,
                                                                                balanceIndex,
                                                                            )
                                                                        ), ["stop"])
                                                                  }, null, 8, ["onClick"]))
                                                                : (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                                    key: 1,
                                                                    icon: "$remove_red_eye",
                                                                    disabled: ""
                                                                  }))
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                                            default: _withCtx(() => [
                                                              (
                                                                            balance &&
                                                                            balance.balances &&
                                                                            balance.balances.length
                                                                        )
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    (
                                                                                balance.balances
                                                                                    .length > 1
                                                                            )
                                                                      ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                                                          key: 0,
                                                                          modelValue: 
                                                                                balance.selected
                                                                            ,
                                                                          "onUpdate:modelValue": [($event: any) => ((
                                                                                balance.selected
                                                                            ) = $event), ($event: any) => (
                                                                                _ctx.selectedBalanceChanged(
                                                                                    balance,
                                                                                )
                                                                            )],
                                                                          items: 
                                                                                balance.balances
                                                                            ,
                                                                          "item-title": 
                                                                                _ctx.getBalanceTypeText
                                                                            ,
                                                                          "return-object": "",
                                                                          outlined: "",
                                                                          "hide-details": "",
                                                                          readonly: 
                                                                                balance.balances
                                                                                    .length === 1
                                                                            ,
                                                                          density: "compact"
                                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title", "readonly"]))
                                                                      : (
                                                                                balance.balances
                                                                                    .length === 1
                                                                            )
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.getBalanceTypeText(
                                                                                    balance.selected,
                                                                                )), 1))
                                                                        : _createCommentVNode("", true)
                                                                  ], 64))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_25, [
                                                      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        balance.glBalance,
                                                                        undefined,
                                                                    )), 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_27, [
                                                      (
                                                                    balance &&
                                                                    balance.selected &&
                                                                    balance.selected.balance
                                                                )
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                        balance.selected.balance,
                                                                        undefined,
                                                                    )), 1))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_29, "-"))
                                                    ]),
                                                    _createElementVNode("td", _hoisted_30, [
                                                      (balance.selected.balance)
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            class: "text-right",
                                                            style: _normalizeStyle(
                                                                    _ctx.differenceColor(
                                                                        balance.selected.balance,
                                                                        balance.glBalance,
                                                                    )
                                                                )
                                                          }, [
                                                            _createElementVNode("strong", null, _toDisplayString(_ctx.difference(
                                                                            balance.selected
                                                                                .balance,
                                                                            balance.glBalance,
                                                                        )), 1)
                                                          ], 4))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_31, "-"))
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _createElementVNode("div", _hoisted_32, [
                                                        (
                                                                        balance.selected &&
                                                                        balance.selected.id &&
                                                                        (balance.selected.type ===
                                                                            'MANUAL' ||
                                                                            balance.selected
                                                                                .type ===
                                                                                'IMPORT_TXT')
                                                                    )
                                                          ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                              key: 0,
                                                              color: "primary",
                                                              onClick: ($event: any) => (
                                                                        _ctx.openBankReconciliationDialog(
                                                                            item,
                                                                            balance.selected.id,
                                                                        )
                                                                    )
                                                            }, null, 8, ["onClick"]))
                                                          : (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                              key: 1,
                                                              disabled: ""
                                                            }))
                                                      ])
                                                    ])
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1032, ["headers", "items"]),
                                              (_ctx.deleteBankReconciliationDialog)
                                                ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                                    key: 0,
                                                    modelValue: _ctx.deleteBankReconciliationDialog,
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.deleteBankReconciliationDialog) = $event)),
                                                    title: "Supprimer le solde relevé",
                                                    onValid: _cache[12] || (_cache[12] = ($event: any) => (
                                                    _ctx.deleteSingleManualBalance(_ctx.toDeleteBankBalanceId)
                                                )),
                                                    validTitle: 'Oui je suis sûr(e)',
                                                    "min-width": "800px"
                                                  }, {
                                                    default: _withCtx(() => _cache[65] || (_cache[65] = [
                                                      _createElementVNode("h4", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir le supprimer ? ", -1)
                                                    ])),
                                                    _: 1
                                                  }, 8, ["modelValue"]))
                                                : _createCommentVNode("", true),
                                              (_ctx.deleteAllSelectionnedBankReconciliationDialog)
                                                ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                                    key: 1,
                                                    modelValue: 
                                                    _ctx.deleteAllSelectionnedBankReconciliationDialog
                                                ,
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((
                                                    _ctx.deleteAllSelectionnedBankReconciliationDialog
                                                ) = $event)),
                                                    title: "Supprimer les soldes manuels",
                                                    onValid: _cache[14] || (_cache[14] = ($event: any) => (_ctx.deleteAllManualBalances())),
                                                    validTitle: 'Oui je suis sûr(e)',
                                                    "min-width": "800px"
                                                  }, {
                                                    default: _withCtx(() => _cache[66] || (_cache[66] = [
                                                      _createElementVNode("h4", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir les supprimer ? ", -1)
                                                    ])),
                                                    _: 1
                                                  }, 8, ["modelValue"]))
                                                : _createCommentVNode("", true),
                                              _createVNode(_component_v_row, {
                                                "no-gutters": "",
                                                class: "pa-4 d-flex justify-space-between"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { class: "mr-4" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn, {
                                                        dense: "",
                                                        rounded: "",
                                                        elevation: "0",
                                                        onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (
                                                            _ctx.newManualBalanceDialog =
                                                                !_ctx.newManualBalanceDialog
                                                        ), ["stop"])),
                                                        class: "d-inline px-2",
                                                        "data-cy": "CheckBankReconciliation-addSoldeManuelReleverBancaire",
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => _cache[67] || (_cache[67] = [
                                                          _createTextVNode(" Ajouter un solde manuel de relevé bancaire ")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      (_ctx.newManualBalanceDialog)
                                                        ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                                            key: 0,
                                                            modelValue: _ctx.newManualBalanceDialog,
                                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newManualBalanceDialog) = $event)),
                                                            title: "Ajouter un solde manuel de relevé bancaire",
                                                            class: "pa-4",
                                                            "min-width": "50vw"
                                                          }, {
                                                            actions: _withCtx(() => [
                                                              _createVNode(_component_v_btn_primary, {
                                                                disabled: _ctx.disabledNewBalance(item),
                                                                rounded: "",
                                                                block: "",
                                                                onClick: ($event: any) => (_ctx.addNewBalance(item)),
                                                                "data-cy": "CheckBankReconciliation-valid",
                                                                size: "x-large"
                                                              }, {
                                                                default: _withCtx(() => _cache[68] || (_cache[68] = [
                                                                  _createTextVNode(" Ajouter ")
                                                                ])),
                                                                _: 2
                                                              }, 1032, ["disabled", "onClick"])
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_row, {
                                                                "no-gutters": "",
                                                                class: "pa-4"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_col, {
                                                                    class: "pr-4",
                                                                    cols: "6"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_oss_date_picker_filled, {
                                                                        modelValue: item.newBalanceDate,
                                                                        "onUpdate:modelValue": ($event: any) => ((item.newBalanceDate) = $event),
                                                                        minDate: 
                                                                        _ctx.accountingPeriod.start
                                                                    ,
                                                                        maxDate: _ctx.accountingPeriod.end,
                                                                        "hide-details": "",
                                                                        textFieldReadOnly: false,
                                                                        "data-cy": "CheckBankReconciliation-date"
                                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "minDate", "maxDate"])
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024),
                                                                  _createVNode(_component_v_col, { cols: "6" }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_oss_text_field_filled, {
                                                                        modelValue: item.newBalance,
                                                                        "onUpdate:modelValue": ($event: any) => ((item.newBalance) = $event),
                                                                        label: "Nouveau solde",
                                                                        outlined: "",
                                                                        dense: "",
                                                                        "hide-details": "",
                                                                        "data-cy": "CheckBankReconciliation-solde"
                                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024),
                                                                  _createVNode(_component_v_spacer),
                                                                  _createVNode(_component_v_col, {
                                                                    class: "d-flex align-center",
                                                                    cols: "3"
                                                                  })
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["modelValue"]))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, { class: "mr-4" }, {
                                                    default: _withCtx(() => [
                                                      (item.balanceReconciliation)
                                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 0,
                                                            dense: "",
                                                            rounded: "",
                                                            elevation: "0",
                                                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$router.push({ name: 'bank' }))),
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[69] || (_cache[69] = [
                                                              _createTextVNode(" Banques - import ")
                                                            ])),
                                                            _: 1
                                                          }))
                                                        : (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 1,
                                                            dense: "",
                                                            rounded: "",
                                                            elevation: "0",
                                                            disabled: "",
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[70] || (_cache[70] = [
                                                              _createTextVNode(" Banques - import ")
                                                            ])),
                                                            _: 1
                                                          }))
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, { class: "mr-4" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn, {
                                                        disable: !item.balanceReconciliation,
                                                        dense: "",
                                                        rounded: "",
                                                        elevation: "0",
                                                        onClick: _cache[18] || (_cache[18] = ($event: any) => (
                                                            _ctx.$router.push({
                                                                name: 'bank',
                                                                query: {
                                                                    auditCheck: 'CheckBTDoublon',
                                                                },
                                                            })
                                                        )),
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => _cache[71] || (_cache[71] = [
                                                          _createTextVNode(" Doublons avec libéllés ")
                                                        ])),
                                                        _: 2
                                                      }, 1032, ["disable"])
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, { class: "mr-4" }, {
                                                    default: _withCtx(() => [
                                                      (item.balanceReconciliation)
                                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 0,
                                                            dense: "",
                                                            rounded: "",
                                                            elevation: "0",
                                                            onClick: _cache[19] || (_cache[19] = ($event: any) => (
                                                            _ctx.$router.push({
                                                                name: 'bank',
                                                                query: {
                                                                    auditCheck:
                                                                        'CheckBTDoublonWithoutWording',
                                                                },
                                                            })
                                                        )),
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[72] || (_cache[72] = [
                                                              _createTextVNode(" Doublons sans libéllés ")
                                                            ])),
                                                            _: 1
                                                          }))
                                                        : (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 1,
                                                            dense: "",
                                                            rounded: "",
                                                            elevation: "0",
                                                            disabled: "",
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[73] || (_cache[73] = [
                                                              _createTextVNode(" Doublons sans libéllés ")
                                                            ])),
                                                            _: 1
                                                          }))
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                      (
                                                            _ctx.selectedBankReconciliationCheckBox.length ===
                                                            0
                                                        )
                                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 0,
                                                            dense: "",
                                                            rounded: "",
                                                            elevation: "0",
                                                            disabled: "",
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[74] || (_cache[74] = [
                                                              _createTextVNode(" Supprimer les soldes manuels ")
                                                            ])),
                                                            _: 1
                                                          }))
                                                        : (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 1,
                                                            dense: "",
                                                            rounded: "",
                                                            elevation: "0",
                                                            onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (
                                                            _ctx.deleteAllSelectionnedBankReconciliationDialog = true
                                                        ), ["stop"])),
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[75] || (_cache[75] = [
                                                              _createTextVNode(" Supprimer les soldes manuels ")
                                                            ])),
                                                            _: 1
                                                          }))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_divider),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"width":"100%"},
                                class: "py-2",
                                onClick: ($event: any) => (_ctx.addRemoveBankAccountManualJustification(item))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pt-0 pl-8",
                                    cols: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "small",
                                        "data-cy": "CheckBankReconciliation-justificationsManuelles",
                                        icon: 
                                                !_ctx.isBankAccountManualJustificationExpanded(item)
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pl-4",
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => _cache[76] || (_cache[76] = [
                                      _createTextVNode(" Justifications manuelles (III) ")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pl-4 justify-end",
                                    cols: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                item.manualJustification,
                                                undefined,
                                            )), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_spacer)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              (_ctx.isBankAccountManualJustificationExpanded(item))
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 1,
                                    "no-gutters": "",
                                    style: {"width":"100%"},
                                    class: "px-4 pb-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          (
                                                item &&
                                                (item.balanceReconciliationFront ||
                                                    (item.justificationLines &&
                                                        item.justificationLines.length))
                                            )
                                            ? (_openBlock(), _createBlock(_component_v_card, {
                                                style: {"background":"#f4f4f4"},
                                                class: "pa-4",
                                                key: _ctx.refreshKey,
                                                elevation: "0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_form, {
                                                    modelValue: _ctx.formIsValid,
                                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formIsValid) = $event))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.justificationLines, (justif, index) => {
                                                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                          _createVNode(_component_v_row, {
                                                            "no-gutters": "",
                                                            class: "mx-2"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, {
                                                                class: "pb-2",
                                                                cols: "3"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_oss_date_picker, {
                                                                    modelValue: justif.date,
                                                                    "onUpdate:modelValue": ($event: any) => ((justif.date) = $event),
                                                                    filterWithoutClosedAccountingPeriods: 
                                                                    true
                                                                ,
                                                                    "hide-details": "",
                                                                    textFieldReadOnly: false,
                                                                    rules: [
                                                                    (v) =>
                                                                        v !== '' ||
                                                                        _ctx.moment(v).isValid() ||
                                                                        _ctx.$t(
                                                                            'settings.shared.errorDate',
                                                                        ),
                                                                ],
                                                                    required: ""
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_spacer),
                                                              _createVNode(_component_v_col, {
                                                                cols: "2",
                                                                class: "pl-2 pb-2"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_oss_text_field, {
                                                                    modelValue: justif.debit,
                                                                    "onUpdate:modelValue": ($event: any) => ((justif.debit) = $event),
                                                                    outlined: "",
                                                                    "hide-details": true,
                                                                    label: "Débit",
                                                                    onChange: ($event: any) => (
                                                                    _ctx.manualJustificationFunction(
                                                                        item,
                                                                        index,
                                                                        'debit',
                                                                    )
                                                                ),
                                                                    suffix: "€",
                                                                    "single-line": "",
                                                                    dense: "",
                                                                    "data-cy": "CheckBankReconciliation-debit"
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                cols: "2",
                                                                class: "pl-2 pb-2"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_oss_text_field, {
                                                                    modelValue: justif.credit,
                                                                    "onUpdate:modelValue": ($event: any) => ((justif.credit) = $event),
                                                                    outlined: "",
                                                                    "hide-details": true,
                                                                    label: "Crédit",
                                                                    onChange: ($event: any) => (
                                                                    _ctx.manualJustificationFunction(
                                                                        item,
                                                                        index,
                                                                        'credit',
                                                                    )
                                                                ),
                                                                    suffix: "€",
                                                                    "single-line": "",
                                                                    dense: ""
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, { cols: "1" })
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, {
                                                                cols: "11",
                                                                class: "pl-2 pb-2"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_textarea, {
                                                                    outlined: "",
                                                                    "hide-details": true,
                                                                    label: "Libellé",
                                                                    modelValue: justif.wording,
                                                                    "onUpdate:modelValue": ($event: any) => ((justif.wording) = $event),
                                                                    disabled: 
                                                                    _ctx.closedPeriod || _ctx.validated
                                                                ,
                                                                    "auto-grow": "",
                                                                    rows: "1",
                                                                    onChange: ($event: any) => (
                                                                    _ctx.manualJustificationFunction(
                                                                        item,
                                                                        index,
                                                                    )
                                                                ),
                                                                    rules: [
                                                                    (v) =>
                                                                        !!v ||
                                                                        'Libellé obligatoire',
                                                                ],
                                                                    required: "",
                                                                    "data-cy": "CheckBankReconciliation-libelle"
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange", "rules"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                cols: "1",
                                                                class: "d-flex align-end text-center px-2 pb-2"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_row, null, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_col, {
                                                                        cols: "6",
                                                                        class: "text-center pl-2 pb-2"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_btn_icon, {
                                                                            icon: "$add",
                                                                            color: "primary",
                                                                            onClick: ($event: any) => (_ctx.addEmptyRow(item))
                                                                          }, null, 8, ["onClick"])
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024),
                                                                      _createVNode(_component_v_col, {
                                                                        cols: "6",
                                                                        class: "text-center pl-2 pb-2"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_btn_trash, {
                                                                            onClick: ($event: any) => (
                                                                            _ctx.deleteRow(item, index)
                                                                        )
                                                                          }, null, 8, ["onClick"])
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          (!!item.justificationLines[index + 1])
                                                            ? (_openBlock(), _createBlock(_component_v_divider, {
                                                                key: 0,
                                                                class: "pb-2"
                                                              }))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      }), 128))
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue"]),
                                                  _createVNode(_component_v_row, {
                                                    "no-gutters": "",
                                                    class: "pt-4"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (item.balanceReconciliationFront)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 0,
                                                            class: "pl-2",
                                                            style: {"color":"red"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" Reste à justifier " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            -item.balanceReconciliationFront,
                                                            { currency: "", DC: true },
                                                        )), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : _createCommentVNode("", true),
                                                      _createVNode(_component_v_spacer),
                                                      _createVNode(_component_v_col, {
                                                        cols: "auto",
                                                        class: "text-right"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_ctx.closedPeriod || _ctx.validated)
                                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                key: 0,
                                                                disabled: "",
                                                                dense: "",
                                                                rounded: "",
                                                                elevation: "0",
                                                                class: "d-inline px-2",
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => _cache[77] || (_cache[77] = [
                                                                  _createTextVNode(" Enregistrer ")
                                                                ])),
                                                                _: 1
                                                              }))
                                                            : (
                                                            _ctx.formIsValid2(item) &&
                                                            !item.balanceReconciliationFront
                                                        )
                                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                  key: 1,
                                                                  onClick: _withModifiers(($event: any) => (_ctx.createReconciliationData(item)), ["stop"]),
                                                                  dense: "",
                                                                  rounded: "",
                                                                  elevation: "0",
                                                                  class: "d-inline px-2",
                                                                  size: "small"
                                                                }, {
                                                                  default: _withCtx(() => _cache[78] || (_cache[78] = [
                                                                    _createTextVNode(" Enregistrer ")
                                                                  ])),
                                                                  _: 2
                                                                }, 1032, ["onClick"]))
                                                              : (_openBlock(), _createBlock(_component_v_btn, {
                                                                  key: 2,
                                                                  disabled: "",
                                                                  dense: "",
                                                                  rounded: "",
                                                                  elevation: "0",
                                                                  class: "d-inline px-2",
                                                                  size: "small"
                                                                }, {
                                                                  default: _withCtx(() => _cache[79] || (_cache[79] = [
                                                                    _createTextVNode(" Enregistrer ")
                                                                  ])),
                                                                  _: 1
                                                                }))
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_col, { cols: "1" })
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_divider),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"width":"100%"},
                                class: _normalizeClass(["py-2", item.balanceReconciliationFront ? 'text-error' : ''])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pt-0 pl-10",
                                    cols: "1"
                                  }),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pl-4",
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => _cache[80] || (_cache[80] = [
                                      _createElementVNode("h4", null, "ECART (I - (II + III))", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pl-4 justify-end",
                                    cols: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    item.balanceReconciliationFront,
                                                    undefined,
                                                )), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_spacer)
                                ]),
                                _: 2
                              }, 1032, ["class"]),
                              _createVNode(_component_v_divider),
                              (item.balance512999)
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 2,
                                    "no-gutters": "",
                                    style: {"width":"100%"},
                                    onClick: ($event: any) => (_ctx.addRemoveBankAccount512999(item)),
                                    class: "py-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        class: "d-flex align-center pt-0 pl-8",
                                        cols: "1"
                                      }, {
                                        default: _withCtx(() => [
                                          (item.balance589999)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                icon: "",
                                                style: {"width":"40px"},
                                                class: "d-inline px-2",
                                                onClick: ($event: any) => (_ctx.addRemoveBankAccount589999(item))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { small: "" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(!_ctx.isBankAccount589999Expanded(item)
                                                        ? "fa-chevron-up"
                                                        : "fa-chevron-down"), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 1,
                                                icon: "",
                                                style: {"width":"40px"},
                                                class: "d-inline px-2",
                                                disabled: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { small: "" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(!_ctx.isBankAccount589999Expanded(item)
                                                        ? "fa-chevron-up"
                                                        : "fa-chevron-down"), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        class: "d-flex align-center pl-4",
                                        cols: "3"
                                      }, {
                                        default: _withCtx(() => _cache[81] || (_cache[81] = [
                                          _createTextVNode(" Ecritures en attente d'encaissement (c/589999) (IV) ")
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        class: "d-flex align-center pl-4 justify-end",
                                        cols: "1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(item.balance589999, undefined)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_spacer)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _withDirectives(_createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"width":"100%"},
                                class: "px-4 pb-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      (_ctx.accountableAccountInfo)
                                        ? (_openBlock(), _createBlock(_component_AccountableAccountBalanceDetail, {
                                            key: 0,
                                            companyId: _ctx.companyId,
                                            accountingPeriodId: _ctx.accountingPeriodId,
                                            accountableAccountInfo: 
                                                _ctx.accountableAccountInfo(
                                                    item.name,
                                                    item.accountableAccount999,
                                                )
                                            ,
                                            notReconciliated: _ctx.withoutLettering,
                                            withoutBank: _ctx.withoutBank,
                                            withoutDocument: _ctx.withoutDocument,
                                            inAccountingTransactions: _ctx.accountingTransactions
                                          }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountInfo", "notReconciliated", "withoutBank", "withoutDocument", "inAccountingTransactions"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1536), [
                                [_vShow, _ctx.isBankAccount589999Expanded(item)]
                              ]),
                              _createVNode(_component_v_divider),
                              (item.balance512999)
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 3,
                                    "no-gutters": "",
                                    style: {"width":"100%"},
                                    class: "py-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        class: "d-flex align-center pt-0 pl-10",
                                        cols: "1"
                                      }),
                                      _createVNode(_component_v_col, {
                                        class: "d-flex align-center pl-4",
                                        cols: "3"
                                      }, {
                                        default: _withCtx(() => _cache[82] || (_cache[82] = [
                                          _createElementVNode("h4", null, [
                                            _createElementVNode("i", null, " SOLDE COMPTABLE GLOBAL (I + IV) ")
                                          ], -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        class: "d-flex align-center pl-4 justify-end",
                                        cols: "1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h4", null, [
                                            _createElementVNode("i", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        item.accountingTheoreticBalance,
                                                        undefined,
                                                    )), 1)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_spacer)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_divider),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"width":"100%"},
                                onClick: ($event: any) => (_ctx.addRemoveBankAccountComment(item)),
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pt-0 pl-8",
                                    cols: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "small",
                                        icon: 
                                                !_ctx.isBankAccountCommentExpanded(item)
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pl-4",
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => [
                                      (item.comment)
                                        ? (_openBlock(), _createElementBlock("b", _hoisted_33, "Commentaires détaillés"))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode("Commentaires détaillés")
                                          ], 64))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_spacer)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              (_ctx.isBankAccountCommentExpanded(item))
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 4,
                                    "no-gutters": "",
                                    style: {"width":"100%"},
                                    class: "px-4 pb-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createBlock(_component_v_card, {
                                            style: {"background":"#f4f4f4","border-radius":"16px"},
                                            class: "pa-4",
                                            key: _ctx.refreshKey,
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_textarea, {
                                                            class: "pt-0 pb-4",
                                                            modelValue: item.comment,
                                                            "onUpdate:modelValue": ($event: any) => ((item.comment) = $event),
                                                            disabled: _ctx.closedPeriod || _ctx.validated,
                                                            "auto-grow": "",
                                                            rows: "1",
                                                            outlined: "",
                                                            "hide-details": "",
                                                            dense: ""
                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_card_title, { class: "pa-0" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_spacer),
                                                          (_ctx.closedPeriod || _ctx.validated)
                                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                key: 0,
                                                                disabled: "",
                                                                rounded: "",
                                                                class: "btn btn_blue",
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => _cache[83] || (_cache[83] = [
                                                                  _createTextVNode(" Enregistrer ")
                                                                ])),
                                                                _: 1
                                                              }))
                                                            : (_openBlock(), _createBlock(_component_v_btn, {
                                                                key: 1,
                                                                rounded: "",
                                                                class: "btn btn_blue",
                                                                onClick: _withModifiers(($event: any) => (
                                                                _ctx.createReconciliationData(item)
                                                            ), ["stop"]),
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => _cache[84] || (_cache[84] = [
                                                                  _createTextVNode(" Enregistrer ")
                                                                ])),
                                                                _: 2
                                                              }, 1032, ["onClick"]))
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_divider),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"width":"100%"},
                                onClick: ($event: any) => (_ctx.addRemoveBankAccountShortComment(item)),
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pt-0 pl-8",
                                    cols: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(!_ctx.isBankAccountShortCommentExpanded(item)
                                                    ? "$fa-chevron-up"
                                                    : "$fa-chevron-down"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex align-center pl-4",
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => [
                                      (item.shortComment)
                                        ? (_openBlock(), _createElementBlock("b", _hoisted_34, "Commentaires synthétiques"))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode("Commentaires synthétiques")
                                          ], 64))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_spacer)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              (_ctx.isBankAccountShortCommentExpanded(item))
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 5,
                                    "no-gutters": "",
                                    style: {"width":"100%"},
                                    class: "px-4 pb-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createBlock(_component_v_card, {
                                            style: {"background":"#f4f4f4","border-radius":"16px"},
                                            class: "pa-4",
                                            key: _ctx.refreshKey,
                                            elevation: "0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_textarea, {
                                                            class: "pt-0 pb-4",
                                                            modelValue: item.shortComment,
                                                            "onUpdate:modelValue": ($event: any) => ((item.shortComment) = $event),
                                                            disabled: _ctx.closedPeriod || _ctx.validated,
                                                            "auto-grow": "",
                                                            rows: "1",
                                                            outlined: "",
                                                            "hide-details": "",
                                                            dense: ""
                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_card_title, { class: "pa-0" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_spacer),
                                                          (_ctx.closedPeriod || _ctx.validated)
                                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                key: 0,
                                                                disabled: "",
                                                                rounded: "",
                                                                class: "btn btn_blue",
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => _cache[85] || (_cache[85] = [
                                                                  _createTextVNode(" Enregistrer ")
                                                                ])),
                                                                _: 1
                                                              }))
                                                            : (_openBlock(), _createBlock(_component_v_btn, {
                                                                key: 1,
                                                                rounded: "",
                                                                class: "btn btn_blue",
                                                                onClick: _withModifiers(($event: any) => (
                                                                _ctx.createReconciliationData(item)
                                                            ), ["stop"]),
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => _cache[86] || (_cache[86] = [
                                                                  _createTextVNode(" Enregistrer ")
                                                                ])),
                                                                _: 2
                                                              }, 1032, ["onClick"]))
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["headers", "items", "loading"]),
                  _createVNode(_component_v_card, {
                    elevation: "0",
                    style: {"background-color":"white","border-radius":"25px"},
                    class: "pa-6 mt-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "auto",
                            class: "ma-auto"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h5", _hoisted_35, " Autres disponibilités - comptes " + _toDisplayString(_ctx.getTextFromStringArray(_ctx.auditItems.othersAccountableAccounts)) + " (sauf " + _toDisplayString(_ctx.getTextFromStringArray(
                                            _ctx.auditItems.excludedOthersAccountableAccounts,
                                        )) + ") ", 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_col, {
                            cols: "auto",
                            class: "ma-auto"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h5", _hoisted_36, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.generalLedgerOthers, undefined)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_col, {
                            cols: "1",
                            class: "d-flex align-centerjustify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    class: "d-flex align-center pa-0"
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    class: "d-flex align-center pa-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        icon: 
                                            _ctx.generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.generalLedgerExpand = !_ctx.generalLedgerExpand)),
                                        style: {"width":"40px"},
                                        class: "d-inline px-2"
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            style: {"background-color":"white","border-radius":"25px","padding":"10px"},
                            class: "my-5"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_GeneralLedger, {
                                        ref: "generalLedger",
                                        companyId: _ctx.companyId,
                                        accountingPeriodId: _ctx.accountingPeriodId,
                                        accountableAccountFilter: 
                                            _ctx.auditItems.othersAccountableAccounts
                                        ,
                                        excludedAccountableAccountFilter: 
                                            _ctx.auditItems.excludedOthersAccountableAccounts || []
                                        ,
                                        inNm1: false,
                                        hideOptions: true,
                                        enableAuditedAccountableAccounts: true,
                                        onQueryDone: _ctx.onQueryDone
                                      }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "excludedAccountableAccountFilter", "onQueryDone"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_spacer)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.generalLedgerExpand]
                      ])
                    ]),
                    _: 1
                  })
                ], 64)),
        (!_ctx.loading && !_ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
              key: 4,
              connectedDocuments: _ctx.connectedDocuments,
              companyId: _ctx.companyId,
              acKey: _ctx.acKey,
              auditCheckResult: _ctx.auditCheckResult || {},
              accountingPeriodId: _ctx.accountingPeriodId || undefined,
              onUnlinkedDocument: _cache[23] || (_cache[23] = ($event: any) => (_ctx.unlinkDocument($event))),
              onShowLinkedDocument: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showLinkedDocument($event)))
            }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
          : _createCommentVNode("", true),
        (!_ctx.loading && !_ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
              key: 5,
              results: _ctx.results,
              companyId: _ctx.companyId
            }, null, 8, ["results", "companyId"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_card, {
          elevation: "0",
          style: {"background-color":"white","border-radius":"25px"},
          class: "pa-6 mt-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "ma-auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                      default: _withCtx(() => _cache[87] || (_cache[87] = [
                        _createElementVNode("h5", { class: "pl-4" }, "Commentaires détaillés", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, {
                  cols: "1",
                  class: "d-flex align-center justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "align-center pa-0"
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "align-center pa-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_icon, {
                              icon: 
                                        _ctx.longGlobalCommentExpand
                                            ? '$fa-chevron-up'
                                            : '$fa-chevron-down'
                                    ,
                              "data-cy": "CheckBankReconciliation-commentaires",
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.longGlobalCommentExpand = !_ctx.longGlobalCommentExpand)),
                              style: {"width":"40px"},
                              class: "d-inline px-2"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.longGlobalCommentExpand)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  transition: "longGlobalCommentExpand"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "px-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_textarea, {
                          modelValue: _ctx.longComment,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.longComment) = $event)),
                          disabled: _ctx.closedPeriod || _ctx.validated,
                          "auto-grow": "",
                          style: {"border":"1px #ededed solid"},
                          outlined: ""
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_spacer),
                                (_ctx.closedPeriod || _ctx.validated)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      disabled: "",
                                      rounded: "",
                                      class: "btn btn_blue",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[88] || (_cache[88] = [
                                        _createTextVNode(" Enregistrer les commentaires ")
                                      ])),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      rounded: "",
                                      class: "btn btn_blue",
                                      onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.storeComments()), ["stop"])),
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[89] || (_cache[89] = [
                                        _createTextVNode(" Enregistrer les commentaires ")
                                      ])),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, {
          elevation: "0",
          style: {"background-color":"white","border-radius":"25px"},
          class: "pa-6 mt-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "ma-auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                      default: _withCtx(() => _cache[90] || (_cache[90] = [
                        _createElementVNode("h5", { class: "pl-4" }, "Commentaires synthétiques", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, {
                  cols: "1",
                  class: "d-flex align-center justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "align-center pa-0"
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "align-center pa-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_icon, {
                              icon: 
                                        _ctx.shortGlobalCommentExpand
                                            ? '$fa-chevron-up'
                                            : '$fa-chevron-down'
                                    ,
                              onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.shortGlobalCommentExpand = !_ctx.shortGlobalCommentExpand)),
                              style: {"width":"40px"},
                              class: "d-inline px-2"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.shortGlobalCommentExpand)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  transition: "shortGlobalCommentExpand"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "px-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_textarea, {
                          modelValue: _ctx.shortComment,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.shortComment) = $event)),
                          disabled: _ctx.closedPeriod || _ctx.validated,
                          "auto-grow": "",
                          style: {"border":"1px #ededed solid"},
                          outlined: ""
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_spacer),
                                (_ctx.closedPeriod || _ctx.validated)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      disabled: "",
                                      rounded: "",
                                      class: "btn btn_blue",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[91] || (_cache[91] = [
                                        _createTextVNode(" Enregistrer les commentaires ")
                                      ])),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      rounded: "",
                                      class: "btn btn_blue",
                                      onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.storeComments()), ["stop"])),
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[92] || (_cache[92] = [
                                        _createTextVNode(" Enregistrer les commentaires ")
                                      ])),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.openChat)
          ? (_openBlock(), _createBlock(_component_Chat, {
              key: 6,
              auditCheckAccountingPeriodKey: _ctx.chatId,
              chatTitle: 'Chat'
            }, null, 8, ["auditCheckAccountingPeriodKey"]))
          : _createCommentVNode("", true),
        (_ctx.dialogAuditCheckDocumentsManager)
          ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
              key: 7,
              modelValue: _ctx.dialogAuditCheckDocumentsManager,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
              disabled: _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
              companyId: _ctx.companyId,
              documentToDisplay: _ctx.documentToDisplay,
              connectedDocuments: _ctx.connectedDocuments || [],
              acKey: _ctx.acKey,
              auditCheckResult: _ctx.auditCheckResult || {},
              accountingPeriodId: _ctx.accountingPeriodId || undefined,
              alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
              onUpsertedAuditCheckResult: _ctx.upsertedACR,
              onResetDialogData: _cache[32] || (_cache[32] = ($event: any) => {
                    _ctx.alreadyLinkedDoc = false;
                    _ctx.documentToDisplay = {};
                })
            }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
          : _createCommentVNode("", true),
        (_ctx.displayActivityDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 8,
              modelValue: _ctx.displayActivityDialog,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
              title: "Activité",
              "valid-title": "Fermer",
              onValid: _cache[34] || (_cache[34] = ($event: any) => (_ctx.displayActivityDialog = false)),
              onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.displayActivityDialog = false)),
              "min-width": "60vw"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UsersActivitiesHistory, {
                  auditCheckKey: _ctx.acKey,
                  accountingPeriodId: _ctx.accountingPeriodId
                }, null, 8, ["auditCheckKey", "accountingPeriodId"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}